import React from "react";

import CalculatorSquareIcon from "root/icons/CalculatorSquare";

// --------------------------------------------------------------
// Секция «Калькулятор» — две подстраницы (WB / Ozon) по аналогии с «Мониторингом»:
// обе указывают на один роут /calculator с разным ?mp=; query отрезается при сборке
// роутов (App servicePages), а сам калькулятор читает ?mp= из URL и показывает нужный МП.
// Доступно без тарифа: openIt здесь + /calculator в whitelist expiredTariff (App/index.js).
const calculatorSection = {
  type: "section",
  title: "Калькуляторы",
  icon: CalculatorSquareIcon,
  children: [
    {
      url: "/calculator?mp=wb",
      component: React.lazy(() => import("root/pages/calculator/Calculator")),
      title: "Wildberries",
      exact: true,
      openIt: true,
    },
    {
      url: "/calculator?mp=ozon",
      component: React.lazy(() => import("root/pages/calculator/Calculator")),
      title: "Ozon",
      exact: true,
      openIt: true,
    },
  ],
};

export default calculatorSection;
